import { prepareEventForDisplay } from "../utils/prepareEventForDisplay";
import { ViewsEnum } from "../contexts/Filter.context";

/**
 * Calcula intervals e prepara eventos com props de renderização
 * 
 * REGRAS DE INTERVALS:
 * 1. Mínimo de 40 minutos em ms entre eventos (30 minutos quando detalhada)
 * 2. Ajusta próximos cards se houver sobreposição
 * 
 * REGRAS DE DISPLAY PROPS:
 * 1. Calcula datas para exibir, flags de atraso (ícone e fundos)
 * 2. Centraliza toda lógica de cálculo aqui
 */
function calculateIntervals(
  itens: Sentinel.Timeline.GroupedEvent,
  isDetalhada: boolean = false
): Sentinel.Timeline.GroupedEvent {
  const MIN_MINUTES = isDetalhada ? 30 : 40;
  const MIN = MIN_MINUTES * 60 * 1000;

  // Ordena os eventos por plannedExecutionStart antes de processar
  // Isso garante que eventos com horário anterior sejam processados primeiro
  const sortedEvents = [...itens.events].sort((a, b) => {
    const startA = new Date(a.plannedExecutionStart).getTime();
    const startB = new Date(b.plannedExecutionStart).getTime();
    return startA - startB;
  });

  const events = sortedEvents.reduce<Sentinel.Timeline.Event[]>(
    (acc, item, index) => {
      const anterior = acc[index - 1] ?? null;

      const pStart = new Date(item.plannedExecutionStart);
      const pEnd = new Date(item.plannedExecutionEnd);
      const plannedDiff = pEnd.getTime() - pStart.getTime();

      // ---------------------------
      // REGRA 1 — mínimo de 40 min
      // Se plannedDiff < MIN usa MIN
      // Senão usa o tamanho real
      // ---------------------------
      const duracaoBase = plannedDiff < MIN ? MIN : plannedDiff;

      let calculatedStart = new Date(pStart);
      let calculatedEnd = new Date(pStart.getTime() + duracaoBase);

      // ---------------------------
      // REGRA 2 — ajustar os próximos cards
      // ---------------------------
      if (anterior?.calculatedEnd) {
        const anteriorEnd = new Date(anterior.calculatedEnd);

        if (calculatedStart < anteriorEnd) {
          calculatedStart = new Date(anteriorEnd);
          calculatedEnd = new Date(
            calculatedStart.getTime() + duracaoBase
          );
        }
      }

      const eventWithIntervals: Sentinel.Timeline.Event = {
        ...item,
        calculatedStart: calculatedStart.toISOString(),
        calculatedEnd: calculatedEnd.toISOString(),
      };

      // Preparar evento com props de renderização (datas, flags de atraso)
      const preparedEvent = prepareEventForDisplay(eventWithIntervals);

      acc.push(preparedEvent);

      return acc;
    },
    []
  );

  return {
    ...itens,
    events,
  };
}

export function useMapDataTimeline(data: Sentinel.Timeline.New, view?: ViewsEnum) {
  const isDetalhada = view === ViewsEnum.detalhada;
  
  let mapGroupD1: Sentinel.Timeline.GroupedEvent[] = [];
  let mapGroupD2: Sentinel.Timeline.GroupedEvent[] = [];

  if (!data?.lanedEvents) return { mapGroupD1, mapGroupD2 };

  if (data.lanedEvents[0]?.groupedEvents?.length) {
    mapGroupD1 = data.lanedEvents[0].groupedEvents.map((group) =>
      calculateIntervals(group, isDetalhada)
    );
  }

  if (data.lanedEvents[1]?.groupedEvents?.length) {
    mapGroupD2 = data.lanedEvents[1].groupedEvents.map((group) =>
      calculateIntervals(group, isDetalhada)
    );
  }

  return { mapGroupD1, mapGroupD2 };
}
